import { render, staticRenderFns } from "./ReparationsAmountType.vue?vue&type=template&id=e504d1b2&scoped=true"
import script from "./ReparationsAmountType.vue?vue&type=script&lang=js"
export * from "./ReparationsAmountType.vue?vue&type=script&lang=js"
import style0 from "./ReparationsAmountType.vue?vue&type=style&index=0&id=e504d1b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e504d1b2",
  null
  
)

export default component.exports